import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  recents: [], // { ...address fields }
  favorites: [], // { ...address fields }
};

const addressBookSlice = createSlice({
  name: 'addressBook',
  initialState,
  reducers: {
    addRecent(state, action) {
      const exists = state.recents.find(
        (r) => JSON.stringify(r) === JSON.stringify(action.payload)
      );
      if (!exists) {
        state.recents.unshift(action.payload);
        if (state.recents.length > 3) state.recents.pop();
      }
    },
    addFavorite(state, action) {
      const exists = state.favorites.find(
        (f) => JSON.stringify(f) === JSON.stringify(action.payload)
      );
      if (!exists) {
        state.favorites.unshift(action.payload);
        if (state.favorites.length > 10) state.favorites.pop();
      }
    },
    removeFavorite(state, action) {
      state.favorites = state.favorites.filter(
        (f) => JSON.stringify(f) !== JSON.stringify(action.payload)
      );
    },
    clearAddressBook(state) {
      state.recents = [];
      state.favorites = [];
    },
  },
});

export const { addRecent, addFavorite, removeFavorite, clearAddressBook } =
  addressBookSlice.actions;
export default addressBookSlice.reducer;
